<template>
	<div>
		<div class="title-area">
			<div class="back" @click="$router.back()">
				<i class="el-icon-arrow-left"></i>
			</div>
			<div>{{ $t(`text38`) }}</div>
		</div>
		<div class="nav-area">
			<div
				class="nav"
				v-for="(item, index) in [
					$t(`text30`),
					$t(`text31`),
					$t(`text32`),
				]"
				:key="index"
				@click="handleNav(index)"
			>
				<span :class="{ active: navState === index }">{{ item }}</span>
			</div>
		</div>
		<div class="content-area">
			<div class="query-area">
				<el-input
					class="inp"
					v-model="listParams.ProjectName"
					:placeholder="$t(`text33`)"
				>
				</el-input>
				<el-select
					v-model="listParams.UnitNumber"
					class="inp"
					clearable
					:placeholder="$t(`text34`)"
				>
					<el-option
						v-for="item in unitNumberOptions"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
				<el-button @click="handleNav(navState)">{{
					$t(`text35`)
				}}</el-button>
			</div>
			<div class="content">
				<el-empty
					:description="$t(`text36`)"
					v-if="listData.length === 0"
				></el-empty>
				<div v-else>
					<div
						class="item-area"
						v-for="(item, index) in listData"
						:key="index"
					>
						<div
							class="icon ending"
							v-if="[3].includes(item.State)"
						>
							<img
								class="image"
								src="@/assets/icon-2.png"
								alt=""
							/>
							<span>{{ $t(`text32`) }}</span>
						</div>
						<div class="icon" v-if="[1, 2].includes(item.State)">
							<img
								class="image"
								src="@/assets/icon-1.png"
								alt=""
							/>
							<span>{{ $t(`text31`) }}</span>
						</div>
						<div class="item-title">{{ $t(`text24`) }}</div>
						<div class="item-txt">
							{{ $t(`text25`) }}：{{ item.ProjectName }}
						</div>
						<div class="item-txt">
							{{ $t(`text26`) }}：{{ item.UnitNumber }}
						</div>
						<div class="item-txt">
							{{ $t(`text27`) }}：{{ item.CreateOn }}
						</div>
						<div class="btn-area">
							<div
								class="btn"
								@click="
									$router.push({
										name: 'Progress',
										params: {
											id: item.ID,
										},
									})
								"
							>
								{{ $t(`text29`) }}
							</div>
						</div>
					</div>
				</div>
				<div
					class="tips"
					v-if="listParams.Page >= totalPage && totalPage !== 0"
				>
					{{ $t(`text37`) }}
				</div>
			</div>
		</div>
		<div
			class="back-top declare"
			v-if="listData.length < 2"
			@click="$router.push('/afterSales')"
		>
			{{ $t(`text55`) }}
		</div>
		<img
			class="back-top"
			style="bottom: 70px;"
			src="@/assets/add.png"
			@click="$router.push('/afterSales')"
		/>
		<img
			class="back-top"
			src="@/assets/top.png"
			@click="backTop"
			v-if="listData.length > 10"
		/>
	</div>
</template>

<script>
import { afterSalesOrderList, getUnitNumbers } from "@/api/qrcode";

export default {
	components: {},
	data() {
		return {
			listParams: {
				UnitNumber: "",
				ProjectName: "",
				State: [],
				Page: 1,
				PerPage: 10,
			},
			listData: [],
			totalPage: 1,
			navState: 0,
			stateList: [[0, 1, 2, 3], [1, 2], [3]],
			unitNumberOptions: [],
		};
	},
	mounted() {
		this.bottomScroll();
		this.getAfterSalesOrderList();
		this.getUnitNumbersData();
	},
	methods: {
		handleNav(e) {
			this.navState = e;
			this.listParams.Page = 1;
			this.listData = [];
			this.getAfterSalesOrderList();
		},
		async getAfterSalesOrderList() {
			this.listParams.State = this.stateList[this.navState];
			let res = await afterSalesOrderList(this.listParams);
			this.listData.push(...res.Data);
			this.totalPage = res.TotalPage;
		},
		bottomScroll() {
			let ele = document.querySelector(".content");
			ele.addEventListener("scroll", () => {
				let scrollTop = ele.scrollTop;
				let clientHeight = ele.clientHeight;
				let scrollHeight = ele.scrollHeight;
				if (scrollTop + clientHeight >= scrollHeight) {
					if (this.listParams.Page >= this.totalPage) return;
					this.listParams.Page++;
					this.getAfterSalesOrderList();
				}
			});
		},
		backTop() {
			let ele = document.querySelector(".content");
			ele.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		},
		async getUnitNumbersData() {
			let { Data } = await getUnitNumbers();
			this.unitNumberOptions = Data;
		},
	},
};
</script>

<style scoped lang="scss">
.back-top {
	position: fixed;
	bottom: 20px;
	left: 10px;
}
.declare {
	display: flex;
	justify-content: center;
	bottom: 105px;
	width: 32px;
	color: #fff;
}
.title-area {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 45px;
	font-size: 24px;
	font-size: 0.5rem;
	.back {
		font-size: 24px;
		position: absolute;
		top: 50%;
		left: 5px;
		transform: translateY(-50%);
	}
}
.nav-area {
	display: flex;
	justify-content: space-evenly;
	background: linear-gradient(to right, #41548b, #7483c9);
	.nav {
		flex: 1;
		text-align: center;
		padding: 10px 0;
		font-size: 16px;
		color: #ccc;
	}
	.active {
		padding-bottom: 5px;
		font-weight: bold;
		color: #fff;
		border-bottom: 2px solid #fff;
	}
}
.content-area {
	position: fixed;
	left: 0;
	right: 0;
	top: 85px;
	bottom: 0;
	background-color: #7b8194;
	padding: 10px;
	background: linear-gradient(to right, #41548b, #7483c9);
	.query-area {
		display: flex;
		align-items: center;
		.tit {
			padding: 0 10px;
			color: #fff;
			font-size: 14px;
		}
		.inp {
			flex: 1;
			height: 40px;
			margin-right: 10px;
		}
	}
	.content {
		position: absolute;
		inset: 10px;
		top: 65px;
		overflow-y: auto;
		.item-area {
			position: relative;
			padding: 15px;
			margin-bottom: 15px;
			border-radius: 10px;
			background: #fff;
			.icon {
				position: absolute;
				right: 0;
				top: 0;
				display: flex;
				align-items: center;
				padding: 5px 10px;
				color: #f45f19;
				font-size: 14px;
				border-radius: 0 0 0 20px;
				background-color: #fdceb3;
				.image {
					width: 25px;
					margin-right: 5px;
				}
			}
			.ending {
				background: #c7f8f4;
				color: #62eddb;
			}
			.item-title {
				font-size: 18px;
			}
			.item-txt {
				font-size: 14px;
				margin-top: 8px;
				color: #aaa;
			}
			.btn-area {
				display: flex;
				justify-content: end;
				.btn {
					padding: 5px 15px;
					background-color: #135192;
					color: #fff;
					font-size: 16px;
					text-align: center;
					border-radius: 20px;
				}
			}
		}
		.tips {
			text-align: center;
			color: #fff;
		}
	}
}
</style>
